import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { maintenanceApi } from '@/api/maintenance';

export function useMaintenance(leaseId: number | null) {
  return useQuery({
    queryKey: ['maintenance', leaseId],
    queryFn: () =>
      maintenanceApi.list(leaseId !== null ? { lease_id: leaseId } : undefined),
  });
}

export function useCreateMaintenance() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: maintenanceApi.create,
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ['maintenance'] });
    },
  });
}
